import { CheckIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

const CreateBookingStepper = ({ steps, activeStep }) => {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      <div className="hidden sm:block">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.id} className="relative flex w-full flex-col items-center">
              {index < steps.length - 1 && (
                <div className={classNames('absolute top-5 left-[calc(50%+1.25rem)] h-0.5 w-[calc(100%-2.5rem)]', activeStep > step.id ? 'bg-dark-600' : 'bg-slate-200')} />
              )}
              <div
                className={classNames(
                  'z-10 flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold transition-colors',
                  activeStep > step.id && 'bg-dark-600 text-white shadow-md',
                  activeStep === step.id && 'border-2 border-dark-600 bg-white text-dark-600 shadow-sm',
                  activeStep < step.id && 'border-2 border-slate-200 bg-white text-slate-400'
                )}
              >
                {activeStep > step.id ? <CheckIcon className="h-5 w-5" /> : step.id}
              </div>
              <span className={classNames('mt-2.5 text-center text-xs font-semibold sm:text-sm', activeStep >= step.id ? 'text-dark-600' : 'text-slate-500')}>
                {t(`bookingProfile.steps.${step.stepKey}`)}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1 sm:hidden">
        {steps.map(step => (
          <div
            key={step.id}
            className={classNames(
              'flex shrink-0 items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold ring-1',
              activeStep === step.id && 'bg-dark-600 text-white ring-dark-600',
              activeStep > step.id && 'bg-dark-600/10 text-dark-600 ring-dark-600/30',
              activeStep < step.id && 'bg-white text-slate-500 ring-slate-200'
            )}
          >
            <span
              className={classNames(
                'flex h-5 w-5 items-center justify-center rounded-full text-[10px]',
                activeStep >= step.id ? 'bg-dark-600 text-white' : 'bg-slate-200 text-slate-500'
              )}
            >
              {activeStep > step.id ? '✓' : step.id}
            </span>
            {t(`bookingProfile.steps.${step.stepKey}`)}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CreateBookingStepper
